import { FC } from 'react';

import { useAgentDatasetMetrics } from './hooks/useAgentDatasetMetrcs';
import { TAgentMarketplaceProject } from './types';

type TProps = {
  agent: TAgentMarketplaceProject;
};

const AgentLatency: FC<TProps> = ({ agent }) => {
  const { p50Latency } = useAgentDatasetMetrics({
    datasets: agent.datasets,
    agentId: agent.id,
  });

  if (!p50Latency) return null;
  return (
    <div className="mt-auto text-sm ">
      <span className="font-semibold text-brand-secondary">
        {p50Latency.toFixed(2)}s
      </span>{' '}
      <span className="text-primary">P50 Latency</span>
    </div>
  );
};

export default AgentLatency;
